import { capitalizeFirstLetter } from '../../../utils'

const UpgradePop = ({ error, handleOpenModal, handleUpgrade }) => {
    const { header, subHeader, body, subBody, flag } = error
    return (
        <div className="modal_body">
            <div className="attached_courses">
                <h2>{header} <span className="mt_2" style={{ textTransform: 'lowercase' }}>{subHeader?.toLowerCase()}</span></h2>
                {
                    <p style={{ textAlign: 'center' }}><span className="mt_2">{body || ''}</span><span className='mt_4 national_semibold'>{subBody}</span></p>
                }
                <form className='d_flex justify_content_center' onSubmit={e => e.preventDefault()}>
                    <input type='text' style={{ display: 'none' }} autoFocus />
                    <input onClick={() => handleOpenModal()} type="submit" autoFocus className="btn btn_gray d_block" value="no" />
                    <input onClick={() => handleUpgrade()} type="submit" autoFocus className="btn btn_primary d_block ml_3" value="yes" />
                </form>
            </div>
        </div>
    )
};

export default UpgradePop;